import React from 'react';
import _ from 'underscore';
import { getGrowthMetrics } from 'actions/ReportingActionCreators';
import Store from 'stores/ReportingStore';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
function getStateFromStore(market) {
    return {
        metrics: Store.getMarketGrowthMetrics(market),
        frequentShippers: Store.getFrequentShippers(),
    };
}
class GrowthMetricTable extends React.Component {
    constructor() {
        super();
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            loading: true,
            data: {
                metrics: [],
                frequentShippers: [],
            },
        };
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange.bind(this));
        this.getMetrics(this.props);
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.getMetrics(nextProps);
    }
    onChange() {
        this.setState({
            loading: false,
            data: getStateFromStore(this.props.market),
        });
    }
    getMetrics(props) {
        const { filters, market, date } = props;
        let query = _.clone(filters);
        query.market = { [market]: true };
        if (filters.customerType.frequentShipper) {
            query.shipperId = this.state.data.frequentShippers;
        }
        else {
            delete query.shipperId;
        }
        getGrowthMetrics(date, query);
    }
    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return React.createElement("p", { className: "lead text-center" }, t('LOADING'));
        }
        const { market, periodName, comparisonPeriodName } = this.props;
        const rows = this.state.data.metrics.map((row, index) => {
            return (React.createElement("tr", { key: index },
                React.createElement("td", null, row.metric),
                React.createElement("td", null, row.metricInPeriod),
                React.createElement("td", null, row.metricInComparisonPeriod),
                React.createElement("td", null, row.growthInMetric)));
        });
        return (React.createElement("div", null,
            React.createElement(Table, { bordered: true, hover: true, striped: true, className: "reporting-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, market === '*' ? t('ALL_MARKETS') : market),
                        React.createElement("th", null, periodName),
                        React.createElement("th", null, comparisonPeriodName),
                        React.createElement("th", null, t('GROWTH')))),
                React.createElement("tbody", null, rows))));
    }
}
export default withTranslation()(GrowthMetricTable);
